import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { getVerticalFluidGridSectionStyles } from './VerticalFluidGridSectionStyles';
import { withBoundaries } from '../../hoc';
import { View } from 'react-native';
import { GridCol, GridContainer, GridRow, getTestId, useBreakpoint } from '@airtel/air-design-system';
var VerticalFluidGridSectionComponent = props => {
  var _props$numberOfColumn = props.numberOfColumns,
    numberOfColumns = _props$numberOfColumn === void 0 ? 1 : _props$numberOfColumn,
    children = props.children,
    style = props.style,
    childStyle = props.childStyle,
    testID = props.testID,
    setRef = props.setRef;
  var itemsRef = useRef([]);
  setRef === null || setRef === void 0 ? void 0 : setRef(itemsRef);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var numberOfColumnAsScreen = isSmallScreen ? 1 : numberOfColumns;
  var renderChildren = columnIndex => {
    var _a;
    if (children && Array.isArray(children)) {
      return (_a = children === null || children === void 0 ? void 0 : children.filter(e => !!e)) === null || _a === void 0 ? void 0 : _a.map((child, index) => {
        if (child && index % numberOfColumnAsScreen == columnIndex) {
          return _jsx(VerticalFluidGridSectionSingleChild, {
            child: child,
            childStyle: childStyle,
            ref: c => {
              itemsRef.current[index] = c;
            }
          }, index.toString());
        }
      });
    }
  };
  var columnRenderer = () => {
    var col = [];
    for (var i = 0; i < numberOfColumnAsScreen; i++) {
      col.push(_jsx(GridCol, Object.assign({
        noTopGutter: true,
        breakpoints: {
          md: 12 / numberOfColumnAsScreen
        }
      }, {
        children: renderChildren(i)
      })));
    }
    return col;
  };
  return _jsx(View, Object.assign({
    style: style
  }, getTestId(testID), {
    children: _jsx(GridContainer, Object.assign({
      noMargin: true
    }, {
      children: _jsx(GridRow, {
        children: columnRenderer()
      })
    }))
  }));
};
export var VerticalFluidGridSectionSingleChild = forwardRef((_ref, ref) => {
  var child = _ref.child,
    childStyle = _ref.childStyle;
  var _useState = useState(false),
    shouldHidden = _useState[0],
    setShouldHidden = _useState[1];
  var verticalFluidGridSectionStyles = getVerticalFluidGridSectionStyles();
  useImperativeHandle(ref, () => ({
    setShouldHidden
  }));
  if (shouldHidden) return null;
  return _jsx(View, Object.assign({
    style: [verticalFluidGridSectionStyles.boxContainer, childStyle]
  }, {
    children: child
  }));
});
VerticalFluidGridSectionComponent.genericRendererKey = 'AirVerticalFluidGridSection';
VerticalFluidGridSectionComponent.isAirSection = true;
export var VerticalFluidGridSection = withBoundaries(VerticalFluidGridSectionComponent);